/**
 * WARNING: This file was auto-generated by svgr. Do not edit.
 */
import * as React from 'react'
import type { SVGProps } from 'react'
/**
 * @internal
 */
const SvgCopyUrl = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={17} height={16} {...props}>
    <path
      fillRule="evenodd"
      d="M3.766 10.664c.414 0 .69-.267.69-.667s-.276-.666-.69-.666h-.69c-.415 0-.691-.267-.691-.667v-6c0-.4.276-.667.69-.667H9.29c.414 0 .69.267.69.667v.667c0 .4.276.666.69.666.415 0 .69-.266.69-.666v-.667c0-1.133-.897-2-2.07-2H3.075c-1.174 0-2.071.867-2.071 2v6c0 1.133.897 2 2.071 2zm10.356-5.333H7.907c-1.174 0-2.071.866-2.071 2v6c0 1.133.897 2 2.07 2h6.214c1.174 0 2.072-.867 2.072-2v-6c0-1.134-.898-2-2.072-2m.69 8c0 .4-.276.666-.69.666H7.907c-.414 0-.69-.266-.69-.666v-6c0-.4.276-.667.69-.667h6.213c.415 0 .69.267.69.667z"
      clipRule="evenodd"
    />
    <mask
      id="copy-url_svg__a"
      width={16}
      height={16}
      x={1}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fillRule="evenodd"
        d="M3.766 10.664c.414 0 .69-.267.69-.667s-.276-.666-.69-.666h-.69c-.415 0-.691-.267-.691-.667v-6c0-.4.276-.667.69-.667H9.29c.414 0 .69.267.69.667v.667c0 .4.276.666.69.666.415 0 .69-.266.69-.666v-.667c0-1.133-.897-2-2.07-2H3.075c-1.174 0-2.071.867-2.071 2v6c0 1.133.897 2 2.071 2zm10.356-5.333H7.907c-1.174 0-2.071.866-2.071 2v6c0 1.133.897 2 2.07 2h6.214c1.174 0 2.072-.867 2.072-2v-6c0-1.134-.898-2-2.072-2m.69 8c0 .4-.276.666-.69.666H7.907c-.414 0-.69-.266-.69-.666v-6c0-.4.276-.667.69-.667h6.213c.415 0 .69.267.69.667z"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#copy-url_svg__a)">
      <path d="M.313 0h16.57v16H.313z" />
    </g>
  </svg>
)
export default SvgCopyUrl
